import { render, staticRenderFns } from "./ProductCombinationsHeader.vue?vue&type=template&id=fbf0a618&scoped=true"
import script from "./ProductCombinationsHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCombinationsHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ProductCombinationsHeader.vue?vue&type=style&index=0&id=fbf0a618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf0a618",
  null
  
)

export default component.exports